/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import * as React from 'react';

import type { StepperDirection } from '../../types';

export interface StepperContextValue {
  current: number;
  direction: StepperDirection;
  totalSteps: number;
  labelBackground: boolean;
}

export const StepperContext = React.createContext<StepperContextValue>({
  current: 0,
  direction: 'vertical',
  totalSteps: 0,
  labelBackground: false,
});
